function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 0H15C15.6 0 16 0.4 16 1V9.1C15.7 9 15.3 9 15 9C11.7 9 9 11.7 9 15C9 17.1 10.1 18.9 11.7 20H1C0.4 20 0 19.6 0 19V1C0 0.4 0.4 0 1 0ZM3 8H8C8.6 8 9 7.5 9 7C9 6.4 8.6 6 8 6H3C2.4 6 2 6.4 2 7C2 7.5 2.4 8 3 8ZM3 4H13C13.6 4 14 3.5 14 3C14 2.4 13.6 2 13 2H3C2.4 2 2 2.4 2 3C2 3.5 2.4 4 3 4ZM18.3999 16.9999L19.6999 18.2999C20.0999 18.6999 20.0999 19.2999 19.6999 19.6999C19.0999 20.2999 18.4999 19.8999 18.2999 19.6999L16.9999 18.3999C16.3999 18.7999 15.6999 18.9999 14.9999 18.9999C12.7999 18.9999 10.9999 17.1999 10.9999 14.9999C10.9999 12.7999 12.7999 10.9999 14.9999 10.9999C17.1999 10.9999 18.9999 12.7999 18.9999 14.9999C18.9999 15.6999 18.7999 16.3999 18.3999 16.9999ZM12.9999 14.9999C12.9999 16.0999 13.8999 16.9999 14.9999 16.9999C16.0999 16.9999 16.9999 16.0999 16.9999 14.9999C16.9999 13.8999 16.0999 12.9999 14.9999 12.9999C13.8999 12.9999 12.9999 13.8999 12.9999 14.9999Z",
  fill: "currentColor"
});

var SvgStudyType = function SvgStudyType(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStudyType, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/studyType.b8010c96.svg";
export { ForwardRef as ReactComponent };